
      // Mobile/touch-only gate — block before main.js initializes the scene
      const coarse = window.matchMedia && window.matchMedia('(pointer: coarse)').matches;
      const fine = window.matchMedia && window.matchMedia('(pointer: fine)').matches;
      if (coarse && !fine) {
        document.body.innerHTML =
          '<div style="position:fixed;inset:0;display:flex;flex-direction:column;' +
          'align-items:center;justify-content:center;padding:2rem;text-align:center;' +
          'background:radial-gradient(circle at center,#15110d 0%,#050402 80%);' +
          "color:#d6cbb8;font-family:'Courier New',monospace;letter-spacing:0.1em;\">" +
          '<h1 style="color:#6b0f0f;letter-spacing:0.3em;font-size:clamp(1.6rem,6vw,2.6rem);margin:0 0 1.5rem;">LE MANOIR</h1>' +
          '<p style="font-size:1.1rem;max-width:32ch;line-height:1.6;margin:0 0 1rem;">' +
          "Ce jeu n'est jouable que sur ordinateur.</p>" +
          '<p style="opacity:0.65;font-size:0.85rem;max-width:36ch;line-height:1.5;">' +
          'Clavier (ZQSD ou flèches) et souris requis. Reviens depuis un PC ou un Mac.</p>' +
          '</div>';
      } else {
        await import('/src/main.js');
      }
    